import * as z from "zod";
import { gql } from "graphql-request";
import { Sys, SysFragment } from "../sys";
import { Image, ImageFragment } from "../image";
import { UnifiedButton, UnifiedButtonFragment } from "../unifiedButton";

export const Milestone = z.object({
  id: z.string(),
  value: z.number().nullable().optional(),
  label: z.string().nullable().optional(),
  image: z
    .object({
      id: z.string(),
      title: z.string(),
      width: z.number(),
      height: z.number(),
      url: z.string(),
    })
    .nullable()
    .optional(),
  voucherId: z.string().nullable().optional(),
  eventId: z
    .union([z.string(), z.array(z.string())])
    .nullable()
    .optional(),
});

export const MilestonesArray = z.array(Milestone).nullable();

export const CarouselEventProgressTrackerEntry = z.object({
  __typename: z.literal("CarouselEventProgressTrackerEntry"),
  sys: Sys,
  entryTitle: z.string().nullable(),
  maxProgress: z.number().nullable(),

  ctaButtonsCollection: z
    .object({
      items: z.array(UnifiedButton).nullish(),
    })
    .nullish(),
  progressValue: z.number().nullable(),
  barColor: z.string().nullable(),

  showEqualDistance: z.boolean().nullable(),

  carouselImage: Image.nullable(),
  carouselImageEn: Image.nullable(),

  milestones: MilestonesArray,
});

export type CarouselEventProgressTrackerEntry = z.infer<
  typeof CarouselEventProgressTrackerEntry
>;

export const CarouselEventProgressTrackerEntryFragment = gql`
  fragment CarouselEventProgressTrackerEntryFragment on CarouselEventProgressTrackerEntry {
    __typename
    sys {
      ...SysFragment
    }

    ctaButtonsCollection {
      items {
        __typename
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
      }
    }

    entryTitle
    maxProgress
    progressValue
    barColor
    showEqualDistance

    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }

    milestones
  }

  ${SysFragment}
  ${ImageFragment}
  ${UnifiedButtonFragment}
`;
